import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ListBusinessComponent } from './list-business/list-business.component';

const routes: Routes = [
  {
    path: '',
    component: ListBusinessComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'admin/business' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BusinessRoutingModule {}
